import { RichTextPreview } from '@/components/editor/rich-text-preview';
import { resolveTextBlockContent } from '@/lib/blocks/text-content';
import { cn } from '@/lib/utils';

interface TextBlockProps {
  content?: unknown;
  className?: string;
}

export { escapeHtml, resolveTextBlockContent } from '@/lib/blocks/text-content';

export function TextBlock({ content, className }: TextBlockProps) {
  const resolvedContent = resolveTextBlockContent(content);

  if (!resolvedContent) {
    return null;
  }

  return <RichTextPreview value={resolvedContent} className={cn('max-w-full', className)} />;
}
